import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme: import("@material-ui/core").Theme) => ({
  root: {
    "& > * + *": {
      marginTop: theme.spacing(1),
    },
  },
  text: {
    height: "8rem",
    overflow: "auto",
    padding: theme.spacing(1),
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    "& > * + *": {
      "&::before": {
        content: `","`,
        paddingRight: theme.spacing(1),
      },
    },
  },
  singleLine: {
    height: "3rem",
  },
  multiline: {
    height: "8rem",
  },
}));

export default function Viewer({
  lessons,
  onClick,
}: {
  lessons: number[];
  onClick: () => void;
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="subtitle1">レッスンID</Typography>
        <Typography
          className={clsx(classes.text, classes.singleLine)}
          variant="subtitle1"
          component="pre"
        >
          {lessons.map((l) => (
            <Link key={l} component={RouterLink} to={`/lessons/${l}`}>
              {l}
            </Link>
          ))}
        </Typography>
      </div>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={onClick}
          >
            編集
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
